import React from 'react'
import { VirtualizedListBase } from '.'
import { VirtualizedListProps } from './virtualized-list.types'
import { virtualizedListDefaultProps } from './constant'

export function VirtualizedList<Item>({
  items,
  ...other
}: VirtualizedListProps<Item>) {
  return (
    <VirtualizedListBase {...other} items={items} itemCount={items.length} />
  )
}

VirtualizedList.defaultProps = virtualizedListDefaultProps
